import React from 'react';

const PageFooter = ({ children, className = '', style = {} }) => {
  const defaultStyle = {
    padding: '0.5rem 0.5rem',
    borderTop: '1px solid rgba(0,0,0,0.1)',
    borderBottomLeftRadius: '0.5rem',
    borderBottomRightRadius: '0.5rem',
    backgroundColor: '#ffffff',
    ...style,
  };

  return (
    <div className={`bg-white ${className}`.trim()} style={defaultStyle}>
      {children}
    </div>
  );
};

export default PageFooter;